import { KeyValuePair } from '../models';

/*
Parse filters from URL
Format: filter=field1.eq(value1),field2.gte(value2)
 */
export function parseFilters(filterParam: string | null): KeyValuePair[] {
  const filtersFromUrl: KeyValuePair[] = [];

  if (filterParam) {
    filterParam.split(',').forEach(filterStr => {
      const match = filterStr.match(/^(\w+)\.(eq|gt|gte|lt|lte|like)\((.*)\)$/);
      if (match) {
        const [, key, operator] = match;
        const isDateRangeFilter =
          key.toUpperCase().includes('DATE') &&
          (operator === 'gte' || operator === 'lte');
        const filterKey = isDateRangeFilter ? `${key}.${operator}` : key;
        // Store the complete filter expression as the value
        filtersFromUrl.push({ key: filterKey, value: filterStr });
      }
    });
  }
  return filtersFromUrl;
}
